import { defineRule } from 'vee-validate'
import { required, email, max, min, length, alpha, integer, alpha_spaces, alpha_num, alpha_dash } from '@vee-validate/rules'

defineRule('required', (value, _, ctx) => {
  if (required(value)) return true
  return `${ctx.field} is required`
})

defineRule('min', (value, [limit], ctx) => {
  if (min(value, { length: limit })) return true
  return `The ${ctx.field} must have at least ${limit} characters`
})

defineRule('max', (value, [limit], ctx) => {
  if (max(value, { length: limit })) return true
  return `The ${ctx.field} must not have more than ${limit} characters`
})

defineRule('email', value => {
  if (email(value)) return true
  return 'Please enter a valid email address'
})

defineRule('length', (value, [len], ctx) => {
  if (length(value, { length: len })) return true
  return `The ${ctx.field} must be ${len} characters`
})

defineRule('alpha', (value, _, ctx) => {
  if (alpha(value)) return true
  return `${ctx.field} only allow alphabet character`
})

defineRule('alpha_num', value => {
  if (alpha_num(value)) return true
  return '{_field_} only allow alphabet and numeric character'
})

defineRule('alpha_dash', (value, _, ctx) => {
  if (alpha_dash(value)) return true
  return `${ctx.field} only allow alphabet, number, dash, or underscore`
})

defineRule('integer', (value, _, ctx) => {
  if (integer(value)) return true
  return `${ctx.field} only allow number`
})

defineRule('alpha_spaces', (value, _, ctx) => {
  if (alpha_spaces(value)) return true
  return `${ctx.field} only allow alphabet and whitespace character`
})

// Custom password rule
defineRule('password', (value, _, ctx) => {
  const minMaxLength = /^[\s\S]{8,32}$/
  const upper = /[A-Z]/
  const lower = /[a-z]/
  const number = /[0-9]/
  const special = /[.!#$%&@]/

  if (
    minMaxLength.test(value) &&
    upper.test(value) &&
    lower.test(value) &&
    number.test(value) &&
    special.test(value)
  ) {
    return true
  }

  return `${ctx.field} must be at least 8 characters with upper case, lower case, number, and special character .!#$%&@`
})

// Password confirmation
defineRule('password_confirm', (value, [target]) => {
  return value === target || 'Password confirmation does not match'
})

// Dropdown selected
defineRule('selected', value => {
  return value > 0 || 'Please select a {_field_} from the dropdown'
})

// ROC rule
defineRule('roc', value => {
  const oldFormat = /^(19|20)[0-9]{2}0[1-6][0-9]{6}$/
  const newFormat = /^\d{1,8}-[a-zA-Z]$/

  return (oldFormat.test(value) || newFormat.test(value)) ||
    'Invalid Company Registration Number format'
})

// Phone rule
defineRule('phone', value => {
  if (value) {
    const mobile = /^(1)[0-46-9][0-9]{7,8}$/
    const landline = /^[3-9][0-9]{7,8}$/

    return (mobile.test(value) || landline.test(value)) ||
      'Invalid Phone Number format' 
  }
  return true  
})

// URL
defineRule('url', value => {
  if (value) {
    const format = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/
    return format.test(value) || 'Invalid URL format'
  }
  return true
})

// Name rule
defineRule('name', (value, _, ctx) => {
  if (value) {
    const format = /^[a-zA-Z\s-@/'.]+$/
    return format.test(value) || `${ctx.field} contains invalid character`
  }
  return true  
})

// BIN rule
defineRule('bin', value => {
  const format = /^0/
  return !format.test(value) || 'Invalid BIN number'
})

// Color hex rule
defineRule('color', value => {
  const format = /^#[A-Fa-f0-9]{6}$/
  return format.test(value) || 'Invalid color code.'
})
